import { numberMoney } from 'Data/format.js'

export function getValue(max_lifetime_coverage, used_lifetime_coverage) {
  if (max_lifetime_coverage === null || max_lifetime_coverage === undefined) {
    return '-'
  }
  return numberMoney(max_lifetime_coverage - (used_lifetime_coverage ?? 0))
}
